<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-group row">
    <label for="company_name" class="label col-sm-3 col-form-label">
      {{ "input.name.label" | translate }}
    </label>
    <div>
      <input
        type="text"
        nbInput
        fullWidth
        [ngClass]="{ isDisabled: !isEditing }"
        id="company_name"
        placeholder="{{ 'input.name.placeholderCompany' | translate }}"
        formControlName="company_name"
        [status]="showInputError('company_name') ? 'danger' : 'basic'"
      />
    </div>
  </div>
  <!--  -->
  <div class="form-group row">
    <label for="phone" class="label col-sm-3 col-form-label">
      {{ "input.phone.label" | translate }}
    </label>
    <div>
      <input
        type="text"
        nbInput
        fullWidth
        [ngClass]="{ isDisabled: !isEditing }"
        id="phone"
        placeholder="{{ 'input.phone.placeholder' | translate }}"
        formControlName="phone"
        [status]="showInputError('phone') ? 'danger' : 'basic'"
      />
    </div>
  </div>

  <div class="group">
    <div class="form-group row">
      <label for="tax_number" class="label col-sm-3 col-form-label">
        {{ "input.taxId.label" | translate }}
      </label>
      <div>
        <input
          type="text"
          nbInput
          fullWidth
          [ngClass]="{ isDisabled: !isEditing }"
          id="tax_number"
          placeholder="{{ 'input.taxId.placeholder' | translate }}"
          formControlName="tax_number"
          [status]="showInputError('tax_number') ? 'danger' : 'basic'"
        />
      </div>
    </div>
    <div class="form-group row">
      <label for="legal_form" class="label col-sm-3 col-form-label">
        {{ "input.legalForm.label" | translate }}
      </label>
      <div>
        <nb-select
          formControlName="legal_form"
          [fullWidth]="true"
          [ngClass]="{ isDisabled: !isEditing }"
        >
          <nb-option-group
            [title]="'input.legalForm.groupDe' | translate"
          >
            <nb-option *ngFor="let f of legalFormsDE" [value]="f.value">
              {{ legalFormLabel(f) }}
            </nb-option>
          </nb-option-group>
          <nb-option-group
            [title]="'input.legalForm.groupEu' | translate"
          >
            <nb-option *ngFor="let f of legalFormsEU" [value]="f.value">
              {{ legalFormLabel(f) }}
            </nb-option>
          </nb-option-group>
          <nb-option [value]="legalFormCustomValue">
            {{ "input.legalForm.custom" | translate }}
          </nb-option>
        </nb-select>

        <input
          *ngIf="isCustomLegalForm"
          type="text"
          nbInput
          fullWidth
          [ngClass]="{ isDisabled: !isEditing }"
          id="legal_form_custom"
          class="legal-form-custom"
          placeholder="{{ 'input.legalForm.customPlaceholder' | translate }}"
          formControlName="legal_form_custom"
        />
      </div>
    </div>
  </div>

  <div class="form-group row">
    <label for="vat_id" class="label col-sm-3 col-form-label">
      {{ "input.vatId.label" | translate }}
    </label>
    <div>
      <input
        type="text"
        nbInput
        fullWidth
        [ngClass]="{ isDisabled: !isEditing }"
        id="vat_id"
        placeholder="{{ 'input.vatId.placeholder' | translate }}"
        formControlName="vat_id"
        [status]="showInputError('vat_id') ? 'danger' : 'basic'"
      />
      <p class="field-hint" *ngIf="!vatIdErrorKey">
        {{ "input.vatId.hint" | translate }}
      </p>
      <p class="field-hint field-hint--error" *ngIf="vatIdErrorKey">
        {{ vatIdErrorKey | translate }}
      </p>
    </div>
  </div>

  <div class="form-group row reverse-charge">
    <label class="label col-sm-3 col-form-label">
      {{ "input.taxStatus.label" | translate }}
    </label>
    <div>
      <!-- Derived from country + VAT ID, not a choice (billing_identity.py
           tax_treatment) — hence a statement, no switch. -->
      <p class="tax-status">{{ taxStatusKey | translate }}</p>
      <p class="field-hint">{{ "input.taxStatus.derived" | translate }}</p>
    </div>
  </div>

  <div class="actions">
    <button
      *ngIf="isEditing"
      type="button"
      nbButton
      status="danger"
      outline
      (click)="isEditing = false"
    >
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      *ngIf="isEditing"
      type="submit"
      nbButton
      status="primary"
      (click)="onSubmit()"
    >
      {{ "buttons.save" | translate }}
    </button>

    <button
      *ngIf="!isEditing"
      type="submit"
      nbButton
      outline
      status="primary"
      (click)="isEditing = true"
    >
      {{ "buttons.edit" | translate }}
    </button>
  </div>
</form>
